import { configureStore } from '@reduxjs/toolkit';
import { enhancedBowtieApi as bowtieApi } from '../api/enhanced/enhanced-bowtie-api';
import { enhancedV4Api as v4Api } from '../api/enhanced/enhanced-v4-api';
import { listenerMiddleware } from './middleware';
import flowDiagram from './slices/diagram';
import runningJobs from './slices/running-jobs';

// Factory so tests can spin up an isolated store (with a fresh RTK Query cache) per case.
export const makeStore = () =>
  configureStore({
    reducer: {
      [v4Api.reducerPath]: v4Api.reducer,
      [bowtieApi.reducerPath]: bowtieApi.reducer,
      flowDiagram,
      runningJobs,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware()
        .prepend(listenerMiddleware.middleware)
        .concat(v4Api.middleware)
        .concat(bowtieApi.middleware),
  });

const store = makeStore();

export default store;

export type AppStore = ReturnType<typeof makeStore>;
export type AppDispatch = AppStore['dispatch'];
export type RootState = ReturnType<AppStore['getState']>;
